import { inject, Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { environment } from '../../../environments/environment';
import { Observable } from 'rxjs';

import { ProductionDashboardSearchCommand, ProductionDashboardWorkOrderDto } from '@app/models/production/production-dashboard';
import { ApiResponse, PaginatedApiResponse } from '@card-software/nexus-utilities';

@Injectable({
  providedIn: 'root',
})
export class ProductionDashboardProxyService {
  private readonly httpClient = inject(HttpClient);
  private readonly baseUrl = `${environment.proxyUrls.productionApi}/api/v1/production-dashboard`;

  public search(
    command: ProductionDashboardSearchCommand,
    pageNumber = 1,
    pageSize = 25,
    sortField?: string,
    sortOrder = -1,
  ): Observable<ApiResponse<PaginatedApiResponse<ProductionDashboardWorkOrderDto>>> {
    let params = new HttpParams().set('pageNumber', pageNumber.toString()).set('pageSize', pageSize.toString());

    if (sortField) {
      params = params.set('sortField', sortField).set('sortOrder', sortOrder.toString());
    }

    return this.httpClient.post<ApiResponse<PaginatedApiResponse<ProductionDashboardWorkOrderDto>>>(`${this.baseUrl}/search`, command, {
      params,
    });
  }
}
